import gql from 'graphql-tag'

const organisationsGetQuery = gql`
  query organisationsGet($offset: Int, $limit: Int, $criteria: Object, $select: Array, $sorting: Object) {
    organisationsGet(
      input: { limit: $limit, offset: $offset, criteria: $criteria, select: $select, sort: $sorting, nested: $nested }
    ) @rest(type: "OrganisationsResult", method: "POST", path: "organisation/list") {
      results
      paging
    }
  }
`

export default organisationsGetQuery
